import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import style from './ModalManager.scss';

const ModalManager = ({ modalState, clearModal }) => {
  const { t } = useTranslation('modal');
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (modalState && modalState.show) {
      const { type, title, content, okText, cancelText, onOk, onCancel, isInstructionModal } =
        modalState;

      switch (type) {
        case 'error':
          modal.error({
            title,
            content,
            icon: null,
            className: style['custom-modal'],
            closable: true,
            closeIcon: <CloseOutlined style={{ fontSize: '16px', color: '#8c8c8c' }} />,
            okText: okText || t('ok'),
            centered: true,
            onOk: () => {
              clearModal();
              if (onOk) onOk();
            },
            onCancel: () => {
              clearModal();
              if (onCancel) onCancel();
            },
          });
          break;

        case 'warning':
          modal.warning({
            title,
            content,
            icon: null,
            className: style['custom-modal'],
            closable: true,
            closeIcon: <CloseOutlined style={{ fontSize: '16px', color: '#8c8c8c' }} />,
            okText: okText || t('ok'),
            centered: true,
            onOk: () => {
              clearModal();
              if (onOk) onOk();
            },
            onCancel: () => {
              clearModal();
              if (onCancel) onCancel();
            },
          });
          break;

        case 'confirm':
          modal.confirm({
            title,
            content,
            icon: null,
            className: style['custom-modal'],
            closable: true,
            closeIcon: <CloseOutlined style={{ fontSize: '16px', color: '#8c8c8c' }} />,
            okText: okText || t('ok'),
            cancelText: cancelText || t('cancel'),
            centered: true,
            onOk: () => {
              clearModal();
              if (onOk) onOk();
            },
            onCancel: () => {
              clearModal();
              if (onCancel) onCancel();
            },
          });
          break;

        case 'info':
          modal.info({
            title,
            content,
            icon: null,
            className: isInstructionModal
              ? `${style['custom-modal']} ${style['instructions-modal']}`
              : style['custom-modal'],
            closable: true,
            closeIcon: <CloseOutlined style={{ fontSize: '16px', color: '#8c8c8c' }} />,
            okText: okText || t('ok'),
            centered: true,
            onOk: () => {
              clearModal();
              if (onOk) onOk();
            },
            onCancel: () => {
              clearModal();
              if (onCancel) onCancel();
            },
          });
          break;

        default:
          break;
      }
    }
  }, [modalState, modal, clearModal, t]);

  return contextHolder;
};

const mapStateToProps = state => ({
  modalState: state.modal,
});

const mapDispatchToProps = dispatch => ({
  clearModal: () => dispatch({ type: 'CLEAR_MODAL' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalManager);
